import { useTranslation } from 'react-i18next';
import { Card } from '../../components/core';
import { Icon, PencilIcon, TrashIcon } from '../../components/core';
import { type SeasonTime } from '../../services/seasonTime.service';
import { editBtnCls, deleteBtnCls } from './styles';
import { formatMonthDay } from '../../utils/formatters';

interface Props {
  seasonTimes: SeasonTime[];
  editingId: string | null;
  cropName: (_id: string) => string;
  regionName: (_id: string) => string;
  onEdit: (_st: SeasonTime) => void;
  onDelete: (_target: { id: string; label: string }) => void;
}

export function SeasonTimeCards({ seasonTimes, editingId, cropName, regionName, onEdit, onDelete }: Props) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-2 sm:hidden">
      {seasonTimes.map(st => (
        <Card
          key={st.id}
          variant="info"
          className={editingId === st.id ? 'ring-2 ring-green-400' : ''}
        >
          <div className="flex items-start justify-between gap-2 px-4 py-3">
            <div className="min-w-0">
              <p className="font-body text-sm font-semibold text-gray-900">
                {cropName(st.cropTypeId)}
                <span className="mx-1 text-gray-400">×</span>
                {regionName(st.regionId)}
              </p>
              <p className="mt-0.5 font-body text-xs text-gray-500">
                {formatMonthDay(st.startMonth, st.startDay, t)} – {formatMonthDay(st.endMonth, st.endDay, t)}
              </p>
            </div>
            <div className="flex shrink-0 gap-2">
              <button
                type="button"
                aria-label={`${t('seasonTimes.editLabel')} ${cropName(st.cropTypeId)} ${regionName(st.regionId)}`}
                onClick={() => onEdit(st)}
                className={editBtnCls}
              >
                <Icon size="xs"><PencilIcon /></Icon>
              </button>
              <button
                type="button"
                aria-label={`${t('seasonTimes.deleteLabel')} ${cropName(st.cropTypeId)} ${regionName(st.regionId)}`}
                onClick={() => onDelete({ id: st.id, label: `${cropName(st.cropTypeId)} × ${regionName(st.regionId)}` })}
                className={deleteBtnCls}
              >
                <Icon size="xs"><TrashIcon /></Icon>
              </button>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
